module.exports = __webpack_public_path__ + "04_long_black.4c6d8056.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/04_long_black.png
// module id = mCHr
// module chunks = 0